import { DeviceModelType } from 'src/app/services/data/devices-data/devices-data.types';

export enum ConsumptionAnalyticsTableColumnName {
  DeviceSerialNumber = 'deviceSerialNumber',
  AccountNumber = 'accountNumber',
  CommDeviceId = 'commDeviceId',
  Port = 'port',
  DeviceModel = 'deviceModel',
  TotalValue = 'totalValue',
  AverageValue = 'averageValue',
  MaximumValue = 'maximumValue',
  MinimumValue = 'minimumValue',
  ServiceLocationAddress = 'serviceLocationAddress',
  MeasuringPeriod = 'measuringPeriod'
}

export enum MeasuringPeriod {
  Yesterday = 'twentyfourHour',
  LastMonth = 'thirtyDay'
}

export enum ConsumptionAnalyticsFieldName {
  MeasuringPeriod = 'MeasuringPeriod',
  GroupId = 'GroupId',
  TotalValue = 'TotalValue',
  MaximumValue = 'MaximumValue',
  MinimumValue = 'MinimumValue',
  AverageValue = 'AverageValue',
  FlowDirection = 'FlowDirection'
}

export interface IndividualConsumptionsItem {
  accountNumber: string;
  accountSubNumber: string;
  customerNumber: string;
  customerSubNumber: string;
  commDeviceId: string;
  deviceModel: DeviceModelType;
  deviceSerialNumber: string;
  deviceUID: string;
  totalValue: number;
  averageValue: number;
  maximumValue: number;
  minimumValue: number;
  mtuDeviceUID: string;
  multiplier: string;
  port: string;
  serviceLocationAddress: string;
  unitOfMeasure: string;
}

export interface IndividualConsumptionsResponse {
  items: IndividualConsumptionsItem[];
  totalCount: number;
}

export interface IndividualConsumptionsTableItem {
  accountNumber: string;
  averageValue: number;
  commDeviceId: string;
  deviceModel: DeviceModelType;
  deviceSerialNumber: string;
  deviceUID: string;
  maximumValue: number;
  minimumValue: number;
  mtuDeviceUID: string;
  multiplier: string;
  port: string;
  serviceLocationAddress: string;
  totalValue: number;
  unitOfMeasure: string;
}
